<template>
  <v-card>
    <v-card-title>
      {{ card_title }}
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
    </v-card-title>

    <v-card-text>
      <div style="margin-bottom: 20px;">
        <v-text-field
          v-model="full_text"
          prepend-icon="mdi-magnify"
          :label="search_label"
          single-line
          hide-details
          @input="on_input"
          autocomplete="off"
          clearable
          :placeholder="search_placeholder"
        />
      </div>

      <slot
        :results="results"
        :loading="loading"
        :footer_props="footer_props"
        :computed_no_data_text="computed_no_data_text"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ImportsSearchCard',
  props: {
    card_title: { type: String, required: true },
    endpoint_base: { type: String, required: true },
    search_label: { type: String, default: 'Search imports...' },
    search_placeholder: { type: String, default: 'Search by file name, imported by, status, date, or record count...' },
    loading_text: { type: String, default: 'Loading imports...' },
    no_data_base_text: { type: String, default: 'No imports available' },
    max_results: { type: Number, default: 1000 },
    auto_load: { type: Boolean, default: true },
    buildParams: { type: Function, default: null },
    transformResults: { type: Function, default: null },
    refresh_key: { type: [String, Number], default: 0 }
  },
  data() {
    return {
      full_text: '',
      results: null,
      loading: false,
      debounce_timer: null
    };
  },
  computed: {
    footer_props() {
      return {
        itemsPerPageText: 'Imports per page:',
        itemsPerPageOptions: [25, 50, 100],
        disableItemsPerPage: false,
        disablePagination: false
      };
    },
    computed_no_data_text() {
      if (this.full_text) {
        return `No items found matching "${this.full_text}"`;
      }
      return this.no_data_base_text;
    }
  },
  mounted() {
    if (this.auto_load) {
      this.load();
    }
  },
  watch: {
    refresh_key() {
      this.load();
    }
  },
  beforeDestroy() {
    if (this.debounce_timer) {
      clearTimeout(this.debounce_timer);
    }
  },
  methods: {
    on_input() {
      if (this.debounce_timer) {
        clearTimeout(this.debounce_timer);
      }
      this.debounce_timer = setTimeout(() => {
        this.load();
      }, 751);
    },

    make_params(full_text) {
      if (this.buildParams) {
        return this.buildParams(full_text, this.max_results);
      }
      return {
        start: 0,
        count: this.max_results,
        full_text: full_text
      };
    },

    load() {
      this.loading = true;

      const organization_id = this.$route.params.organization_id;
      const params = this.make_params(this.full_text);

      this.$rc.rest({
        spinner: false,
        endpoint: 'LIST: ' + this.endpoint_base + '/search/' + organization_id,
        params,
        on_success: (data) => {
          this.loading = false;
          const raw_results = (data && data.results) ? data.results : [];
          this.results = this.transformResults ? this.transformResults(raw_results) : raw_results;
          this.$emit('loaded', this.results);
        },
        on_error: (error) => {
          this.loading = false;
          this.$rc.alert(
            'Error Loading Imports',
            'Unable to load import history: ' + error.message
          );
        }
      });
    },

    refresh() {
      this.load();
    }
  }
};
</script>

<style scoped>
/* Table styling is inherited from parent pages */
</style>

